import {ArrowBackIcon, BackBtnWithDarkTheme, Body1, Box, ButtonWithDarkTheme, styled, AddIcon, Tooltip, DoneIcon, CloseIcon} from '../../../ui-library';
import {tooltipClasses} from '@mui/material';
import React from 'react';


export const ContainerBox = styled(Box)`
    display: flex;
    flex-direction: column;
    padding: 5px;
    border-radius: 10px;
    background:  ${({ theme }) => theme.palette.grey[700]};
    width: 600px;
    min-height: 200px;
    box-sizing: border-box;
`;

export const BackBtn = styled(BackBtnWithDarkTheme)`
    font-size: 12px;
    width: fit-content;
    height: fit-content;
`;

export const ContinueBtn = styled(ButtonWithDarkTheme)`
    font-size: small;
    width: fit-content;
`;

export const AddClassBtn = styled(ButtonWithDarkTheme)`
    font-size: small;
    width: fit-content;
    margin-right: 60px;
`;
export const BackIcon = styled(ArrowBackIcon)`
    font-size: 18px;
`;

export const ImageContainerBox = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
`;

export const ButtonContainerBox = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-top: 10px;
`;

export const Title = styled(Body1)`
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 600;
    margin-top: 15px;
    margin-left: 10px;
`;

export const MainTitleContainerBox = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
`;

export const TitleContainerBox = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
`;

export const CustomTooltip = styled(({ className, ...props }: any) => (
    <Tooltip {...props} classes={{ popper: className }} />
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
))(({ theme }) => ({
    cursor: 'pointer',
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'rgba(17, 24, 39, 0.9)',
    },
}));


export const ButtonAddToClassContainerBox = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

`;

export const SuccessIcon = styled(DoneIcon)`
    margin-right: 20px;
`;

export const ErrorsIcon = styled(CloseIcon)`
    margin-right: 20px;
`;

export const InputContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    gap: 14px;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 10px;
    width: 250px;
`;

export const AddToClassBtn = styled(ButtonWithDarkTheme)`
    font-size: small;
    width: fit-content;
    margin-right: 10px;
`;

export const AddClassIcon = styled(AddIcon)`
    margin-top: 15px;
    cursor: pointer;
    color: #90CAF9;
`;

export const ScrollImages = styled(Box)`
    overflow-x: auto;
    max-height: 656px;
`;

export const RegenerateBtn = styled(BackBtnWithDarkTheme)`
    font-size: 12px;
    width: fit-content;
    height: fit-content;
`;

export const DropBoxBox = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

